import { OrdersState } from '@/contracts/store/OrdersContracts'

// Cross-component signal that the signed-in customer's order set changed.
//
// The Header's "My Orders" badge reads its orders snapshot once at boot and on
// sign-in. The return from SmartPay is a full page load at /payment/result, so
// that boot read races the /payment/result confirm and sees the PRE-confirm
// state — a first order placed mid-session never reached the badge until a
// reload (STG tester report, 2026-09-22). PayResult bumps the revision once the
// order is confirmed and the orders composable refetches on it: one extra
// orders read per confirmed payment, signed-in only — never per route change,
// and never signed-out (IRM's 2026-07-15 report was the badge firing with
// nobody logged in; the composable's isAuthenticated gate still applies).
export const Orders =
{
    namespaced: true,
    state: (): OrdersState => (
    {
        revision: 0
    }),
    getters:
    {
        getRevision(state: OrdersState): number
        {
            return state.revision
        }
    },
    mutations:
    {
        markChanged(state: OrdersState): void
        {
            state.revision++
        }
    }
}
